"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _idgen = _interopRequireDefault(require("./idgen"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var Switch = function Switch(_ref) {
  var checked = _ref.checked,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      id = _ref.id,
      offLabel = _ref.offLabel,
      onLabel = _ref.onLabel;
  var computedId = id || (0, _idgen.default)();
  return _react.default.createElement("div", {
    className: "switch"
  }, _react.default.createElement("label", {
    htmlFor: computedId
  }, offLabel, _react.default.createElement("input", {
    id: computedId,
    disabled: disabled,
    onChange: onChange,
    type: "checkbox",
    defaultChecked: checked
  }), _react.default.createElement("span", {
    className: "lever"
  }), onLabel));
};

Switch.propTypes = {
  /*
   * label for off
   */
  offLabel: _propTypes.default.string.isRequired,

  /*
   * label for on
   */
  onLabel: _propTypes.default.string.isRequired,

  /*
   * onChange callback
   */
  onChange: _propTypes.default.func,

  /*
   * override id
   * @default idgen()
   */
  id: _propTypes.default.string,

  /*
   * disabled input
   */
  disabled: _propTypes.default.bool,

  /*
   * initialise checkbox checked
   */
  checked: _propTypes.default.bool
};
var _default = Switch;
exports.default = _default;